module.exports = __webpack_public_path__ + "img/castlevania.3aa9e513.png";